import { useNavigate, useOutletContext } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'
import { EditPeriodPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AddOrEditPeriodModal from 'modules/work_schedules/components/AddOrEditPeriodModal'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import overlapPeriods from 'modules/work_schedules/store/collections/overlapPeriods'
import schedules from 'modules/work_schedules/store/collections/schedules'

const EditPeriodModalPage = () => {
  const { navigation } = useNavigation()
  const { id, periodId } = useStrictParams<'id' | 'periodId'>()
  const period = overlapPeriods.get(Number(periodId))
  const workSchedule = schedules.get(Number(period?.attributes.schedule_id))
  const navigate = useNavigate()
  const { dayConfigurations } = useOutletContext<RouteContextParams>()
  const dayConfigurationsByPeriod = dayConfigurations.getDayConfigsByPeriod(Number(periodId))

  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data, loading } = useQuery(EditPeriodPageDocument, {
    variables: {
      scheduleId: Number(period?.attributes.schedule_id),
      companyId,
    },
  })

  const onSuccess = () => {
    navigate(navigation.settings.workSchedule.id.fullPath({ id }))
  }

  const canAssignEmployees = data?.workSchedule.schedule?.canAssignEmployeesPolicy.can ?? false
  const canReassignAll = data?.workSchedule.schedule?.canReassignEmployeesPolicy.can ?? false
  const canAddBreaks = data?.features.featuresConnection.nodes[0]?.enabled ?? false

  if (loading) {
    return <Loading />
  }

  return (
    <ResponsivePage.Body showHeader={false} variant="wide" loading={loading} error={null}>
      <Section.TwoThirds
        illustration="calendar-clock"
        title={i18n.t('settings.work_schedule.period_section.edit_period_modal.title')}
        description={i18n.t('settings.work_schedule.period_section.edit_period_modal.description')}
      >
        <AddOrEditPeriodModal
          onClose={onSuccess}
          onSuccess={onSuccess}
          period={period}
          workSchedule={workSchedule}
          dayConfigurations={dayConfigurationsByPeriod}
          canAssignEmployees={canAssignEmployees}
          canReassignAll={canReassignAll}
          canAddBreaks={canAddBreaks}
        />
      </Section.TwoThirds>
    </ResponsivePage.Body>
  )
}

export default EditPeriodModalPage
